import HideSageSyncAnalysisIssuesMutation from '../../../../mutations/mission_control/hide_sage_sync_analysis_issues_mutation';
import Util from '../../../../forecast-app/shared/util/util';
export const hideIssues = (ids, successCallback) => {
    console.log('DEBUG hideIssues ids:' + ids);
    Util.CommitMutation(HideSageSyncAnalysisIssuesMutation, {
        ids: ids,
    }, successCallback);
    successCallback();
};
